export default __webpack_public_path__ + "static/images/054d2bc8d47648c7385024a4b700bc76.png";